import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useProfile } from "@/_actions/userActions";
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import * as Yup from "yup";
import apiClient from "@/utils/apiClient";
import { Spinner } from "@/components/ui/spinner";

const accountTypes = [
  { value: "real_estate", label: "Inmobiliaria" },
  { value: "developer", label: "Desarollador inmobiliario" },
  { value: "advertiser", label: "Broker" },
];

const intentionOptions = [
  {
    value: "Publicar propiedades en venta",
    label: "Publicar propiedades en venta",
  },
  {
    value: "Publicar propiedades en renta",
    label: "Publicar propiedades en renta",
  },
  {
    value: "Gestionar leads de anuncios",
    label: "Gestionar leads de anuncios",
  },
  {
    value: "Integrar un CRM inmobiliario",
    label: "Integrar un CRM inmobiliario",
  },
  {
    value: "Realizar investigaciones a inquilinos",
    label: "Realizar investigaciones a inquilinos",
  },
  {
    value: "Conectar con otros promotores",
    label: "Conectar con otros promotores",
  },
];

const validationSchema = Yup.object().shape({
  account_type: Yup.string().required("Selecciona un tipo de cuenta"),
  intentions: Yup.array()
    .min(1, "Selecciona al menos una intención")
    .required("Selecciona al menos una intención"),
});

export default function ActivitySelection({ callBack }) {
  const { data: profile, mutate: mutateProfile } = useProfile();

  const form = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      account_type: "",
      intentions: [],
    },
  });

  const onSubmit = async (data) => {
    await apiClient.patch(`/clients/update/pro/${profile.client}`, {
      account_type: data.account_type,
    });
    await apiClient.patch(`clients/me/needs/`, {
      goals: data.intentions,
    });
    callBack();
  };

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="space-y-8 max-w-screen-md mx-auto"
      >
        {/* Tipos de cuenta - Radio Group */}
        <div className="bg-neutral-100 border-gray-900 border rounded-xl p-10 space-y-3">
          <FormField
            control={form.control}
            name="account_type"
            render={({ field }) => (
              <FormItem className="space-y-3">
                <FormLabel className="text-base">Elige una opción</FormLabel>
                <FormDescription>Soy</FormDescription>
                <FormControl>
                  <RadioGroup
                    onValueChange={field.onChange}
                    defaultValue={field.value}
                    className="flex flex-col space-y-1"
                  >
                    {accountTypes.map((type) => (
                      <FormItem
                        key={type.value}
                        className="flex items-center space-x-3 space-y-0 "
                      >
                        <FormControl>
                          <RadioGroupItem value={type.value} id={type.value} />
                        </FormControl>
                        <Label
                          htmlFor={type.value}
                          className="font-normal cursor-pointer w-full bg-white p-2"
                        >
                          {type.label}
                        </Label>
                      </FormItem>
                    ))}
                  </RadioGroup>
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        {/* Intenciones - Checkboxes */}

        <div className="bg-neutral-100 border-gray-900 border rounded-xl p-10 space-y-3">
          <FormField
            control={form.control}
            name="intentions"
            render={() => (
              <FormItem>
                <div className="mb-4">
                  <FormLabel className="text-base">
                    Elige una o varias opciónes
                  </FormLabel>
                  <FormDescription>Necesito</FormDescription>
                </div>
                {intentionOptions.map((item) => (
                  <FormField
                    key={item.value}
                    control={form.control}
                    name="intentions"
                    render={({ field }) => {
                      return (
                        <FormItem
                          key={item.value}
                          className="flex flex-row items-start space-x-3 space-y-0 "
                        >
                          <FormControl>
                            <Checkbox
                              checked={field.value?.includes(item.value)}
                              onCheckedChange={(checked) => {
                                return checked
                                  ? field.onChange([...field.value, item.value])
                                  : field.onChange(
                                      field.value?.filter(
                                        (value) => value !== item.value
                                      )
                                    );
                              }}
                            />
                          </FormControl>
                          <FormLabel className="font-normal w-full bg-white p-2">
                            {item.label}
                          </FormLabel>
                        </FormItem>
                      );
                    }}
                  />
                ))}
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        <Button
          type="submit"
          className="w-full"
          disabled={form.formState.isSubmitting}
        >
          {form.formState.isSubmitting ? (
            <>
              <Spinner /> Cargando...
            </>
          ) : (
            "Siguiente"
          )}
        </Button>
      </form>
    </Form>
  );
}
